import { AiOutlineCheckSquare } from "react-icons/ai";
export const AboutData = [
  {
    icon: <AiOutlineCheckSquare fill="#1172ce" size={30} />,
    info: "Browse Website",
  },
  {
    icon: <AiOutlineCheckSquare fill="#1172ce" size={30} />,
    info: "Choose Service",
  },
  {
    icon: <AiOutlineCheckSquare fill="#1172ce" size={30} />,
    info: "Book Session",
  },
  {
    icon: <AiOutlineCheckSquare fill="#1172ce" size={30} />,
    info: "Get Feedback",
  },
];
